import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';

const SelectCustom = (props) => {
  return (
    <Form.Group controlId="exampleForm.SelectCustom">
      {props.label && <Form.Label className="text-light">{props.label}</Form.Label>}
      <Form.Select
        placeholder={props.placeholder}
        onChange={(e) => props.onCheckedItem(e.target.value)}
        value={props.value}
        className="input-control"
      >
        {props.placeholder && <option value="">{props.placeholder}</option>}
        {props.choices.map((choice, i) => (
          <option value={choice.id} key={choice.id}>
            {choice.value}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

SelectCustom.propTypes = {
  choices: PropTypes.array.isRequired,
  label: PropTypes.string,
  onCheckedItem: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
};

export default SelectCustom;
